import { MDSSelectMenuItemProps } from "@/mds/components/menu/select-menu/select-menu.types";
import { MDSMenuItem } from "@/mds/components/menu/menu-item";
import { StyledListBoxItem } from "./select-menu.style";

export const MDSSelectMenuItem = ({
  onClick, // Extract onClick to prevent double clicks
  onHover,
  itemRef,
  ...props
}: MDSSelectMenuItemProps) => {
  return (
    <StyledListBoxItem
      ref={itemRef}
      data-mds-name="select-menu-item"
      id={props.id}
      key={props.id}
      aria-label={props.label}
      textValue={props.textValue ?? props.label}
      onPress={onClick}
      onHoverStart={onHover}
      isDisabled={props.isDisabled}
    >
      <MDSMenuItem {...props} />
    </StyledListBoxItem>
  );
};
